export default __webpack_public_path__ + "static/media/check.5701b303.svg";